import {
  START_LOADING,
  END_LOADING,
  WHATSAPP_LOGIN,
  WHATSAPP_LOGIN_ERROR,
  SET_SOCKET_CONNECTED,
  SET_SOCKET_DATA,
  SET_SOCKET_ERROR,
  CONNECT_WHATSAPP,
  CONNECT_WHATSAPP_ERROR,
  WHATSAPP_LOGOUT,
  WHATSAPP_LOGOUT_ERROR,
  SET_SOCKET_INSTANCE,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  whatsApp: null,
  isConnecteddata: null,
  error: null,
  socketError: null,
  WhatsAppConnectData: null,
  whatsAppConnectError: null,
  socket: null,
};

const communication = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
        socketError: null,
        whatsAppConnectError: null,
      };
    case END_LOADING:
      return { ...state, isLoading: false };
    case WHATSAPP_LOGIN:
      return {
        ...state,
        whatsApp: action.payload,
      };
    case SET_SOCKET_INSTANCE:
      return {
        ...state,
        socket: action.payload,
      };
    case WHATSAPP_LOGOUT:
      return {
        ...state,
        whatsApp: action.payload,
      };
    case CONNECT_WHATSAPP:
      return {
        ...state,
        WhatsAppConnectData: action.payload,
      };
    case SET_SOCKET_CONNECTED:
      return {
        ...state,
        isConnected: action.payload,
      };
    case SET_SOCKET_DATA:
      return { ...state, data: action.payload };
    case WHATSAPP_LOGIN_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case WHATSAPP_LOGOUT_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_SOCKET_ERROR:
      return { ...state, socketError: action.payload };
    case CONNECT_WHATSAPP_ERROR:
      return { ...state, whatsAppConnectError: action.payload };
    default:
      return state;
  }
};

export default communication;
